import types from './actionTypes'

const setViewPort = (payload: any) => ({
  type: types.SET_VIEW_PORT,
  payload
})

export default {
  setViewPort
}
